import { Injectable } from '@angular/core';
import { DataResponseHttp } from '../../../http-models/data-response.http';
import { DataResponseModel } from '../../../models/apis/data-response.model';
import { BaseMapper } from '../../base.mapper';

@Injectable({
    providedIn: 'root',
})
export class GetNotificationDownloadLinkMapper
    implements
    BaseMapper<DataResponseModel<string>, DataResponseHttp<string>>
{

    convertFrom(
        http: DataResponseHttp<string>
    ): DataResponseModel<string> {

        let response = {
            isError: http.isError,
            errors: http.errors,
            data: http.data
        } as DataResponseModel<string>;

        return response;
    }
}
